"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
Object.defineProperty(exports, "__esModule", { value: true });
exports.WifiProvisioningStatus = void 0;
var WifiProvisioningStatus;
(function (WifiProvisioningStatus) {
    WifiProvisioningStatus[WifiProvisioningStatus["NONE"] = 0] = "NONE";
    WifiProvisioningStatus[WifiProvisioningStatus["SERIAL_INIT"] = 1] = "SERIAL_INIT";
    WifiProvisioningStatus[WifiProvisioningStatus["PROVISIONING"] = 2] = "PROVISIONING";
    WifiProvisioningStatus[WifiProvisioningStatus["CONNECTING"] = 3] = "CONNECTING";
    WifiProvisioningStatus[WifiProvisioningStatus["CONNECTION_ERROR"] = 4] = "CONNECTION_ERROR";
    WifiProvisioningStatus[WifiProvisioningStatus["LOOKING_FOR_SERVER"] = 5] = "LOOKING_FOR_SERVER";
    WifiProvisioningStatus[WifiProvisioningStatus["COULD_NOT_FIND_SERVER"] = 6] = "COULD_NOT_FIND_SERVER";
    WifiProvisioningStatus[WifiProvisioningStatus["DONE"] = 7] = "DONE";
    WifiProvisioningStatus[WifiProvisioningStatus["OBTAINING_MAC_ADDRESS"] = 8] = "OBTAINING_MAC_ADDRESS";
    WifiProvisioningStatus[WifiProvisioningStatus["NO_SERIAL_LOGS_ERROR"] = 9] = "NO_SERIAL_LOGS_ERROR";
    WifiProvisioningStatus[WifiProvisioningStatus["NO_SERIAL_DEVICE_FOUND"] = 10] = "NO_SERIAL_DEVICE_FOUND";
})(WifiProvisioningStatus = exports.WifiProvisioningStatus || (exports.WifiProvisioningStatus = {}));
